export default __webpack_public_path__ + "static/media/video-play-thumbnail.9f17219c.jpg";